/**
 * src/web/components/chat-room-settings-page.jsx
 */

import React from 'react'
import connect from '../../connects/chat-room-settings-page.js'
import {
  SettingsPage,
  SettingsPanel,
} from './settings-page'
import ChatRoomFormPanel from './chat-room-form-panel.jsx'
import ChatRoomMembersPanel from './chat-room-members-panel.jsx'
import ChatRoomDeletePanel from './chat-room-delete-panel.jsx'

class ChatRoomSettingsPage extends React.Component {
  render () {
    const {
      t,
      chatRoom,
      chatRoomName,
      user,
      onClose,
      name,
      open = false,
    } = this.props

    return (
      <SettingsPage title={t('label:チャットルーム設定')}
          active={open}
          onCloseDialog={onClose}
          name={name}
          initialName="chat_room_members">
        <SettingsPanel name="chat_room_profile"
            params={{ chatRoom: chatRoom, user:user }}
            label={t('label:基本設定')}
            icon="group_work"
            component={ChatRoomFormPanel} />
        <SettingsPanel name="chat_room_members"
            params={{ chatRoom: chatRoom, user: user }}
            label={t('label:メンバー管理')}
            icon="people"
            component={ChatRoomMembersPanel} />
        <SettingsPanel name="chat_room_delete"
            params={{ chatRoomName: chatRoomName }}
            label={t('label:削除')}
            icon="remove_circle"
            component={ChatRoomDeletePanel} />
      </SettingsPage>      
    )
  }
}

export const RawChatRoomSettingsPage = ChatRoomSettingsPage
export default connect(ChatRoomSettingsPage)



// WEBPACK FOOTER //
// ./src/web/components/chat-room-settings-page.jsx